import { jsx as _jsx } from "react/jsx-runtime";
var PriceTag = function PriceTag(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      id: "Mask",
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.5607 8.4395C11.1467 9.0245 11.1467 9.9755 10.5607 10.5605C9.97467 11.1465 9.02567 11.1465 8.43967 10.5605C7.85367 9.9755 7.85367 9.0245 8.43967 8.4395C9.02567 7.8535 9.97467 7.8535 10.5607 8.4395ZM5.83417 12.8916L11.8662 18.9246L18.9242 11.8666L12.8922 5.83361L5.10717 5.1076L5.83417 12.8916ZM11.8662 20.9986C11.4012 20.9986 10.9372 20.8216 10.5822 20.4686L4.16517 14.0506C4.00017 13.8866 3.89817 13.6686 3.87617 13.4366L3.00417 4.0926C2.97717 3.7966 3.08217 3.5036 3.29317 3.2926C3.50417 3.0816 3.79617 2.9746 4.09317 3.0046L13.4372 3.8766C13.6692 3.89761 13.8862 3.99961 14.0512 4.16461L20.4682 10.5816C20.8112 10.9246 21.0002 11.3806 21.0002 11.8666C21.0002 12.3526 20.8112 12.8086 20.4682 13.1516L13.1512 20.4676C12.7972 20.8216 12.3322 20.9986 11.8662 20.9986Z",
      fill: color
    })
  });
};
export default PriceTag;